import cn from "clsx";
import { PropsWithChildren } from "react";

type OrderedListProps = PropsWithChildren & {
  className?: string;
};
export function OrderedList({ className = "", children }: OrderedListProps) {
  return <ol className={cn("list-inside list-decimal", className)}>{children}</ol>;
}
